// extracted by mini-css-extract-plugin
export default {"whatsappButton":"WhatsAppButton_whatsappButton__Gp+R1"};